import { render, staticRenderFns } from "./vFormIMAGE.vue?vue&type=template&id=b76c34d6&scoped=true&"
import script from "./vFormIMAGE.vue?vue&type=script&lang=js&"
export * from "./vFormIMAGE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76c34d6",
  null
  
)

export default component.exports